module.exports = __webpack_public_path__ + "media/images/flags/WS-2d6a27d1b25a010a5234c6d9fd34370c.svg";